import React from 'react';

import  ScienceExhibition2024  from 'views/ScienceExhibition2024';
const BlogNewsroomPage = () => {

return <ScienceExhibition2024/>
};

export default BlogNewsroomPage;